import { ApolloClient, InMemoryCache, ApolloProvider, gql } from '@apollo/client';

const graphqlUrl = `${process.env.REACT_APP_API_URL}/graphql`;

const client = new ApolloClient({
  uri: graphqlUrl,
  cache: new InMemoryCache(),
});

export default client;
